import i18n from '@/locales';
import { createApp } from 'vue';
import ProjectPurchaseBrowsing from '@/components/purchase/ProjectPurchaseBrowsing.vue';

const app = createApp({});
app.use(i18n);
app.component('ProjectPurchaseBrowsing', ProjectPurchaseBrowsing);
app.mount('#projectPurchaseBrowsingApp');
